@if(this.processing) {
  <div class="db-switcher-container">
    <div class="router-load-spinner-overlay">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
    
    <span>Logging in to database {{database}} ...</span>
  </div>
} @else {
  <span class="db-switcher-container">Now logged in to database {{database}}</span>
}
